export const INVOICE_TABS = [
  { value: "total", label: "Total No. of Invoices" },
  { value: "current_month", label: "Current Month Invoice" },
  { value: "paid", label: "Paid" },
  { value: "overdue", label: "Overdue" },
  { value: "cancelled", label: "Cancelled / Rejected" },
];

export const invoicePermission = (type, section, key, action = "view") =>
  `invoices.${type}.${section}.${key}${action ? `.${action}` : ""}`;

export const invoiceActionPermission = (type, action) => `invoices.${type}.actions.${action}`;

export const invoiceListColumnPermission = (type, column) =>
  invoicePermission(type, "list_columns", column);

export const invoiceListControlPermission = (type, control) =>
  invoicePermission(type, "list_controls", control);

export const invoiceFormFieldPermission = (type, mode, field) =>
  invoicePermission(type, `${mode}_fields`, field);

export const invoiceWorkflowPermission = (type, action) =>
  invoiceActionPermission(type, action);
